import React from 'react';
import { Box } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import { RootState } from '@Common/models/redux/store';
import Carousel from 'nuka-carousel';
import { StyledSteps } from '../StyledComponents';

const useStyles = makeStyles((theme) => ({
  mobileSlider: {
    '& .slider-frame': {
      //   overflow: 'unset',
    },
    '& .slider-slide': {
      '&:first-child': {
        zIndex: 2,
      },
    },
    '& .slider-control-bottomcenter': {
      '& .paging-item button svg': {
        display: 'none',
      },
      '& .paging-item': {
        marginLeft: 6,
      },
      '& .paging-item button': {
        width: '8px',
        height: '8px',
        borderRadius: '100px',
        opacity: '1 !important',
        backgroundColor: `${theme.specialColors.CIRCULAR_PROGRESS}  !important`,
        padding: 0,
      },
      '& .paging-item.active button': {
        backgroundColor: `${theme.palette.primary.main} !important`,
        width: '18px',
        borderRadius: '50px',
      },
    },
  },
}));

function StepsBlock() {
  const classes = useStyles();
  const isMobile = useSelector((state: RootState) => state.common.platform.isMobile);
  const isTablet = useSelector((state: RootState) => state.common.platform.isTablet);

  return (
    <>
      {isMobile || isTablet ? (
        <Box mx="-30px">
          <Carousel
            className={classes.mobileSlider}
            slideWidth={1}
            renderCenterLeftControls={null}
            renderCenterRightControls={null}
            // framePadding="0 32px 0 0"
          >
            <StyledSteps
              isMobile
              step="01"
              description="There are a ton of options out there, and each has their pros and cons. Here on the <a target='_blank' href='https://quillbot.com/blog/'>QuillBot blog</a>, we are, of course, partial to our own <a href='/co-writer'>Co-Writer</a>, which has the rest of our tools built in for an even smoother writing experience."
              title="Pick your AI writer"
              bgColor="rgba(47, 117, 60, 1)"
            />
            <StyledSteps
              isMobile
              step="02"
              description="The reason this isn't the first step is because some AI writing tools will create topics for you, if that's something you need help with. Once you have your topic, the fun can really begin."
              title="Pick your topic"
              bgColor="rgba(47, 117, 60, 1)"
            />
            <StyledSteps
              isMobile
              step="03"
              description="Really, that's it. Once you type a few words, the AI writer will take over and not only finish your sentence, but create the next one. And the next one. And so on, and so forth. All it needs is that first initial taste of your writing to understand what to do."
              title="Start writing"
              bgColor="rgba(18, 72, 28, 1)"
            />
          </Carousel>
        </Box>
      ) : (
        <>
          <StyledSteps
            step="01"
            description="There are a ton of options out there, and each has their pros and cons. Here on the <a target='_blank' href='https://quillbot.com/blog/'>QuillBot blog</a>, we are, of course, partial to our own <a href='/co-writer'>Co-Writer</a>, which has the rest of our tools built in for an even smoother writing experience."
            title="Pick your AI writer"
            bgColor="rgba(47, 117, 60, 1)"
          />
          <Box pt="32px" />
          <StyledSteps
            step="02"
            description="The reason this isn't the first step is because some AI writing tools will create topics for you, if that's something you need help with. Once you have your topic, the fun can really begin."
            title="Pick your topic"
            bgColor="rgba(47, 117, 60, 1)"
          />
          <Box pt="32px" />
          <StyledSteps
            step="03"
            description="Really, that's it. Once you type a few words, the AI writer will take over and not only finish your sentence, but create the next one. And the next one. And so on, and so forth. All it needs is that first initial taste of your writing to understand what to do."
            title="Start writing"
            bgColor="rgba(18, 72, 28, 1)"
          />
        </>
      )}
    </>
  );
}
export default StepsBlock;
